(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/hooks/use-race-data.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/hooks/use-race-data.js');
"use strict";



const {
  useEffect
} = React;
const {
  format,
  parseISO
} = dateFns;
const {
  productIds
} = svs.utils.products;
const {
  gameTypes,
  gameTypeToSubProductId
} = svs.racing.common.constants;
const {
  ImageTypes,
  getImageOptions
} = svs.racing.common.imageOptions;
const {
  cache,
  helpers: {
    useAsyncSafeState
  }
} = svs.components.sport.quickplayModal;
const logger = new svs.core.log.Logger('svs.sport.QuickplayModal');
const _getRaceItemCacheKey = _ref => {
  let {
    productId,
    drawNumber
  } = _ref;
  return "race_".concat(productId, "_").concat(drawNumber);
};

function useRaceData(_ref2) {
  let {
    productId,
    drawNumber,
    onError
  } = _ref2;
  const [normalizedData, setNormalizedData] = useAsyncSafeState(null);
  useEffect(() => {
    const handleError = error => {
      logger.info("useRaceData() failed: \"".concat(error === null || error === void 0 ? void 0 : error.message, "\" (productId ").concat(productId, ")"));
      if (onError) {
        onError(error);
      }
    };
    _refreshRaceAsync({
      productId,
      drawNumber,
      setNormalizedData,
      handleError
    });
  }, [productId, drawNumber, onError, setNormalizedData]);
  return normalizedData;
}

async function _refreshRaceAsync(_ref3) {
  let {
    productId,
    drawNumber,
    setNormalizedData,
    handleError
  } = _ref3;
  try {
    if (!productId || productId !== productIds.RACING || !drawNumber) {
      return;
    }
    const cacheKey = _getRaceItemCacheKey({
      productId,
      drawNumber
    });
    const cachedData = cache.getData({
      itemKey: cacheKey
    });
    if (cachedData) {
      setNormalizedData(cachedData);
      return;
    }
    const rawData = await _queryRacingDrawAsync({
      drawNumber
    });
    const normalizedData = _normalizeRace({
      rawData,
      drawNumber
    });
    if (normalizedData) {
      cache.setData({
        itemKey: cacheKey,
        data: normalizedData
      });
      setNormalizedData(normalizedData);
    }
  } catch (error) {
    handleError(error);
  }
}

async function _queryRacingDrawAsync(_ref4) {
  let {
    drawNumber
  } = _ref4;
  const {
    response
  } = await svs.core.jupiter.callAsync({
    method: 'GET',
    path: "/racing/1/race/draw/".concat(drawNumber)
  });
  if (response.error || !response.race) {
    var _response$error;
    throw new Error(((_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.message) || 'Fetching of race-data failed');
  }
  return response.race;
}

function _normalizeRace(_ref5) {
  var _meeting$track;
  let {
    rawData,
    drawNumber
  } = _ref5;
  const {
    raceNumber,
    draws,
    startTimeTentative,
    meeting,
    participants,
    numberOfParticipants,
    raceName
  } = rawData;
  if (!Array.isArray(draws) || !Array.isArray(participants) || !numberOfParticipants || !meeting) {
    throw new Error('Failed to normalize race: Missing data about draws, participants and meeting');
  }
  const currentDraw = draws.find(item => item.drawNumber === drawNumber);
  if (!currentDraw) {
    throw new Error('Failed to normalize race: Can\'t find draw');
  }
  const silksFormattedDate = meeting !== null && meeting !== void 0 && meeting.date ? format(parseISO(meeting.date), 'yyyyMMdd') : undefined;
  const _mapParticipant = item => ({
    number: item.participantNumber,
    horseName: item.horseName,
    driverName: item.driverName || null,
    silkImageOptions: item.silks ? getImageOptions(item.silks, silksFormattedDate, ImageTypes.CouponSilk) : null
  });
  const subProductId = String(currentDraw.userProduct).toUpperCase();
  const isHighFive = subProductId === String(gameTypeToSubProductId[gameTypes.TOPP5]).toUpperCase();
  return {
    drawNumber,
    productName: currentDraw.productName,
    subProductId,
    isHighFive,
    closeTime: startTimeTentative,
    trackName: meeting === null || meeting === void 0 || (_meeting$track = meeting.track) === null || _meeting$track === void 0 ? void 0 : _meeting$track.trackName,
    raceNumber,
    participants: participants.map(_mapParticipant),
    numberOfParticipants,
    raceName
  };
}
setGlobal('svs.components.sport.quickplayModal.hooks', {
  useRaceData
});

 })(window);